
export const EDIT_UPLOAD_UPDATE_ADD_LABEL = "Добавление обновления"

export const EDIT_UPLOAD_UPDATE_ADD_BUTTON = "Добавить обновление"
